module.exports = __webpack_public_path__ + "1_0_59/img/The Shard.c6b7360d.jpg";